import React from 'react';
import PropTypes from 'prop-types';

import { path } from 'ramda';

const BoundingBox = ({
    start,
    end,
    imageUrl,
    noEvents,
    onClick,
    width,
    height,
}) => {
    if (!imageUrl) return null;
    const style = {
        left: path(['0'], start),
        top: path(['1'], start),
        width: path(['0'], end),
        height: path(['1'], end),
    };

    const imageStyle = {
        left: -style.left,
        top: -style.top,
        width: `${width}px`,
        height: `${height}px`,
    };

    const noPointerEvents = noEvents ? '-pointer-events--none' : '';

    return (
        <div
            className={`gds-lens gds-lens--display gds-lens--valid ${noPointerEvents}`}
            style={style}
        >
            <div
                className="gds-lens__viewport --box-viewport gds-lens__viewport--no-icon"
                onClick={onClick}
            >
                <img
                    className="gds-lens__image image-annotation"
                    style={imageStyle}
                    src={imageUrl}
                />
            </div>
            <div className="gds-lens__bracket gds-lens__bracket--t-l" />
            <div className="gds-lens__bracket gds-lens__bracket--t-c" />
            <div className="gds-lens__bracket gds-lens__bracket--t-r" />
            <div className="gds-lens__bracket gds-lens__bracket--c-l" />
            <div className="gds-lens__bracket gds-lens__bracket--c-r" />
            <div className="gds-lens__bracket gds-lens__bracket--b-l" />
            <div className="gds-lens__bracket gds-lens__bracket--b-c" />
            <div className="gds-lens__bracket gds-lens__bracket--b-r" />
        </div>
    );
};

BoundingBox.propTypes = {
    start: PropTypes.array.isRequired,
    end: PropTypes.array.isRequired,
    imageUrl: PropTypes.string,
    noEvents: PropTypes.bool,
    onClick: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
};

export default BoundingBox;
